import React, { useEffect } from 'react';
import { Container } from 'reactstrap';
import { connect } from 'react-redux';
import { Route, Switch } from 'react-router-dom';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import {
  RIDE_BOOKING_UNIT_PATH,
  RIDE_BOOKING_SEARCH_PATH,
  RIDE_BOOKING_PASSENGERS_PATH,
  RIDE_BOOKING_SELECTION_SEAT_PATH,
} from '../../../config/paths';
import RoundTrip from './RoundTrip';
import { getActiveSalesSession } from '../../../actions';
import RideBookingNavbar from './RideBookingNavbar';
import RideBookingSeatSelection from './seat-selection/RideBookingSeatSelection';
import RideBookingWrapper from './pessengers/RideBookingWrapper';
import Loader from '../../common/Loader';
import Alert from '../../common/informative/Alert';

const RideBookingModule = ({
  dispatchGetActiveSalesSession,
  user,
  currentStep,
  gettingActiveSalesSession,
  activeSalesSession,
}) => {
  useEffect(() => {
    if (user) dispatchGetActiveSalesSession({ source: '/ride-booking/search' });
  }, []);

  if (gettingActiveSalesSession) return <Loader />;

  if (user && !user.salesSessionUserId && activeSalesSession.isEmpty()) {
    return (
      <Container>
        <Alert message="No hay ninguna sesión de ventas activa." />
      </Container>
    );
  }

  return (
    <div>
      <Container fluid>
        <h1>Venta Rápida</h1>
        <RideBookingNavbar currentStep={currentStep} />
        <Switch>
          <Route exact path={RIDE_BOOKING_UNIT_PATH} render={RoundTrip} />
          <Route exact path={RIDE_BOOKING_SEARCH_PATH} render={RoundTrip} />
          <Route
            exact
            path={RIDE_BOOKING_SELECTION_SEAT_PATH}
            render={RideBookingSeatSelection}
          />
          <Route
            exact
            path={RIDE_BOOKING_PASSENGERS_PATH}
            render={RideBookingWrapper}
          />
        </Switch>
      </Container>
    </div>
  );
};

RideBookingModule.propTypes = {
  dispatchGetActiveSalesSession: PropTypes.func.isRequired,
  user: PropTypes.shape({
    id: PropTypes.number.isRequired,
    salesSessionUserId: PropTypes.number,
  }).isRequired,
  currentStep: PropTypes.number.isRequired,
  gettingActiveSalesSession: PropTypes.bool.isRequired,
  activeSalesSession: PropTypes.instanceOf(Immutable.Map).isRequired,
};

const mapStateToProps = ({ authentication, BookingUnit, SalesUnit }) => ({
  user: authentication.get('user'),
  currentStep: BookingUnit.Booking.get('currentStep'),
  gettingActiveSalesSession: SalesUnit.SalesSession.getIn([
    'active',
    'loading',
  ]),
  activeSalesSession: SalesUnit.SalesSession.getIn(['active', 'content']),
});

const mapDispatchToProps = {
  dispatchGetActiveSalesSession: getActiveSalesSession,
};

export default connect(mapStateToProps, mapDispatchToProps)(RideBookingModule);
